<template>
    <div class="listing-status">
        <span :class="statusStyle"> {{locationStatus}}</span>
        <button v-if="locationStatus == 'Pending Approval' && isAdmin && editState" class="td-btn success ml-2 slim" @click="changeStatus(LocationStatus.Active)" title="Approve Listing">
            Approve
        </button>
        <button v-if="locationStatus == 'Not Published' && isAdmin && editState" class="td-btn danger ml-2 slim" @click="changeStatus(LocationStatus.Inactive)" title="Set to Inactive">
            Set to Inactive
        </button>
        <button v-if="locationStatus == 'Inactive' && isAdmin && editState" class="td-btn success ml-2 slim" @click="changeStatus(LocationStatus.Active)" title="Set to Active">
            Set to Active
        </button>
        <button v-if="editLocation.status != LocationStatus.Active && locationStatus != 'Purge' && isAdmin && editState" class="td-btn danger ml-2 slim" @click="changeStatus(LocationStatus.Purge)" title="Purge">
            Purge
        </button>
    </div>
   
</template>

<script>
    import script from './ListingStatus';
    export default script;</script>
<style lang="less">
    @import "./ListingStatus";
</style>